
const TermsofUses = () => {
    return (
        <>
          
            <div
                className="relative h-[656px] md:h-[464px] lg:h-[524px] w-full bg-cover bg-center flex flex-col justify-center items-center text-center "
                style={{
                    backgroundImage: `url('/images/TermsAndConditions/image1.webp')`, 
                }}
            >
                <div className="absolute inset-0 bg-black bg-opacity-20"></div>
                <div className="relative z-10 text-white px-6 sm:px-10 max-w-2xl">
                 
                    <h2 className="lora-display mb-4">
                        Terms and Conditions
                    </h2>

                    {/* <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold mb-4">
                        Articles & Resources
                    </h1> */}
                    {/* Description */}
                    <p className="outfit text">
                        Effective date january 25 2025
                    </p>
                </div>
            </div>

        
           <section className="flex flex-col justify-center items-center  w-full lg:px-[106px] md:px-[64px] px-4 lg:mt-[200px] lg:mb-[200px] md:mt-[180px[ md:mb-[180px] pt-[120px] pb-[100px] ">
                <div className="lg:w-[1025px]  md:w-[706px]  w-[362px] h-[520px]   mx-auto">
                    <ul className="list-disc pl-6 lg:space-y-10 md:space-y-4  space-y-3 text-black   outfit-text">
                        <li>All bookings are subject to availability and confirmation. A valid ID must be provided at the time of check-in.</li>
                        <li>Cancellation terms follow the policy outlined during booking. Refunds are processed per the policy.</li>
                        <li>Early check-in or late check-out is subject to availability and may incur additional charges.</li>
                        <li>Payments must be completed through the Airbnb platform or approved methods. Any outstanding dues must be settled before check-in.</li>
                        <li>Guests must follow house rules, including no smoking indoors, no parties, and maintaining quiet hours.</li>
                        <li>A refundable security deposit may be required and will be returned after a satisfactory inspection of the property.</li>
                        <li>Guests are responsible for any damages caused during their stay and may be charged accordingly.</li>
                        <li>Pets are not allowed inside the apartment.</li>
                        <li>Znorm homes are not responsible for any loss, injury, or damage to personal property during the stay.</li>
                        <li>Personal information provided by guests will only be used for booking and communication purposes.</li>
                        <li>It reserves the right to terminate guests' stay without refund in case of policy violation.</li>
                    </ul>
                </div>

            </section>



           

        </>
    )
}
export default TermsofUses